import clsx from "clsx";

export const HeroTitle = ({ children, classNames }) => {
    return <h1 className={clsx(
        "text-heading-1 phone:text-heading-3 tablet:text-heading-1 tablet:leading-[75.6px] desktop:text-display font-semibold text-basier-circle-semibold text-neutral-100 leading-[64.8px]",
        classNames
    )}>{children}</h1>;
};

export const HeroDescription = ({ children, title, classNames }) => {
    return <p title={title} className={clsx(
        "text-neutral-50 font-normal phone:text-[16px] tablet:text-[16px] text-[16px] tracking-text !leading-[27.2px] pt-4 phone:pt-4",
        classNames
    )}>{children}</p>;
};

export const CardTitle = ({ children, classNames }) => {
    return <h1 className={clsx(
        "font-medium text-md tablet:text-heading-4 text-heading-4 text-neutral-100 phone:leading-[36px] leading-[42px]",
        classNames
    )}>{children}</h1>;
};

export const Subtitle = ({ classNames, children, isLight }) => {
    return <p className={clsx(
        "font-normal relative z-30 phone:text-[16px] text-[16px] tracking-text !leading-[27.2px]",
        isLight ? "text-neutral-10" : "text-neutral-50",
        classNames
    )}>{children}</p>;
};

export const TextBadge = ({ children, isLight, classNames }) => {
    return <h3 className={clsx(
        "font-semibold text-[16px] phone:leading-[24px] tablet:leading-[24px] desktop:leading-[24px] uppercase pb-4 phone:text-[16px]",
        isLight ? "text-neutral-10" : "text-primary-main",
        classNames
    )}>{children}</h3>;
};

export const SectionTitle = ({ children, isLight, classNames }) => {
    return <h1 className={clsx(
        "font-semibold relative z-30 tablet:text-heading-3 phone:leading-[48px] tablet:leading-[54px] phone:text-[32px] tracking-text-sm text-heading-2 pb-4",
        isLight ? "text-neutral-10" : "text-neutral-100",
        classNames
    )}>{children}</h1>;
};

export const QuestionTitle = ({ children, classNames }) => {
    return <h1 className={clsx(
        "text-heading-4 phone:text-heading-5 phone:leading-[36px] font-semibold text-neutral-100 tracking-text-sm leading-[42px]",
        classNames
    )}>{children}</h1>;
};

export const QuestionText = ({ children, classNames }) => {
    return <p className={clsx(
        "text-[#4D586C] font-normal",
        "tablet:text-lg desktop:text-lg text-md",
        "tracking-text phone:leading-[27.2px] tablet:leading-[30.6px] desktop:leading-[30.6px]",
        classNames
    )}>{children}</p>;
};

export const ContentText = ({ children, classNames }) => {
    return <p className={clsx(
        "font-normal relative z-30 phone:text-[16px] text-neutral-50 text-[16px] tracking-text !leading-[27.2px]",
        classNames
    )}>{children}</p>;
};